export default __webpack_public_path__ + "static/media/WhatsApp Image 2023-04-29 at 9.53.43 PM (1).47cd3608.jpeg";